export const NOT_PERFORMED = {
  id: 'not_performed',
  label: 'Non eseguito',
};

export const PERFORMED_POSITIVE_HIGH_RISK = {
  id: 'performed_positive_high_risk',
  label: 'Eseguito, esito positivo (rischio elevato)',
};

export const PERFORMED_NEGATIVE = {
  id: 'performed_negative',
  label: 'Eseguito, esito negativo',
};

export const PERFORMED_INCONCLUSIVE_FAILED = {
  id: 'performed_inconclusive_failed',
  label: 'Eseguito, non conclusivo/fallito',
};

export const UNKNOWN = {
  id: 'unknown',
  label: 'Non noto',
};
